import { render, staticRenderFns } from "./HelpdeskWatchingTicketsView.vue?vue&type=template&id=62aae424"
import script from "./HelpdeskWatchingTicketsView.vue?vue&type=script&lang=js"
export * from "./HelpdeskWatchingTicketsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports